import { render, staticRenderFns } from "./ProjectFileUploadPopup.vue?vue&type=template&id=06a88e92&scoped=true&lang=pug&"
import script from "./ProjectFileUploadPopup.vue?vue&type=script&lang=js&"
export * from "./ProjectFileUploadPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileUploadPopup.vue?vue&type=style&index=0&id=06a88e92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a88e92",
  null
  
)

export default component.exports